import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField } from "@material-ui/core";
import Button from "@mui/material/Button";

import { withRouter } from "react-router-dom";

import DetailCard from "../common/DetailCard";
import ToTop from "../common/ToTop";
import {
  getInfoList,
} from "../../actions/subscribe";
import InfiniteScroll from "react-infinite-scroll-component";


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      minHeight: "110px",
      padding: "18px 24px 6px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      height: "40px",
      marginTop: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      minWidth: "70px",
      height: "40px",
      marginLeft: "20px !important",
      background: "#3276C3",
      borderRadius: "0 !important",
    },

    container: {
      padding: "16px 18px 20px 24px",
    },
    list: {
      width: "1px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    switch: {
      width: "68px !important",
      height: "22px !important",
      padding: "0 12px !important",
      "& .MuiSwitch-track": {
        width: "44px",
        height: "22px",
        borderRadius: "11px",
      },
      "& .MuiSwitch-switchBase": {
        padding: "0",
        "&:hover": {
          background: "none",
        },
        "&.Mui-checked+.MuiSwitch-track": {
          backgroundColor: "#3DBD7D",
        },
        "& .MuiTouchRipple-root": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
        "& .MuiSwitch-thumb": {
          background: "#fff",
          transform: "translate(14px, 1px)",
        },
      },
    },
    switchLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#5F6876",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#170F5F !important",
        borderColor: "#170F5F !important",
      },
    },
    labelBox: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 'calc(100% + 48px)',
      marginLeft: '-24px',
      marginTop: '16px',
      padding: '16px 24px 0',
      borderTop: '1px solid #eee',
      background: '#fff',
    },
    label: {
      height: "25px",
      margin: "0 10px 10px 0",
      lineHeight: "23px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #ddd",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    }
  };
};

class Info extends Component {
  state = {
    keyword: "",
    error: "",
    page: 1,
    count: 0,
    fileList: [],
    labelList: ['全部', '批件发布', '人类遗传资源', '创新与优先', '标准物质', '其他汇总'],
    selectLabel: ''
  };

  componentDidMount() {
    this.loadMore(true)
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handlePreview = (url) => {
    const w = window.open("ablut:blank");
    localStorage.setItem("file_url", url);
    w.location.href = "/viewer";
  };

  loadMore = (isInit) => {
    const param = {
      lable: this.state.selectLabel,
      page: isInit ? 1 : this.state.page,
      keyword:this.state.keyword
    };
    getInfoList(param).then((res) => {
      if (res && res.results) {
        this.setState({
          fileList: isInit
            ? [].concat(res.results)
            : this.state.fileList.concat(res.results),
          page: res.next ? this.state.page + 1 : 0,
          count: res.count,
        });
      }
    });
  };


  searchSpecialFile = () => {
    this.setState(
      {
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  //回车事件
  onKeyDownchange = (e) => {
    if (e.keyCode == 13){
    this.setState(
      {
        page: 1,
      },
      () => this.loadMore(true)
    );
  }
  };

  showResult = () => {
    if (this.state.keyword == "") {
      if (this.state.count == 0) {
        return "没有找到您想要的内容，请联系管理员添加";
      } else return "没有了";
    } else {
      if (this.state.count == 0) {
        return "没有找到您想要的内容，请更换关键词";
      } else return "没有了";
    }
  };

  handleClickLabel = (label) => {
      this.setState({
        selectLabel: label
      },()=>this.searchSpecialFile())
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className={classes.root}>
        <Grid container className={classes.search}>
          <Grid item className={classes.result}>
            <Typography className={classes.line}>
              <span className={classes.title}>汇总信息表</span>
              一共有搜索到
              <span className={classes.total}>{this.state.count}</span>
              个结果
            </Typography>
          </Grid>
          <Grid className={classes.inputGroup}>
            <Grid item className={classes.line}>
              <TextField
                error={this.state.error}
                label="文件名搜索"
                placeholder=""
                value={this.state.keyword}
                helperText={this.state.error}
                variant="outlined"
                name="keyword"
                onKeyDown={(e) => this.onKeyDownchange(e)}
                onChange={this.onChange}
                className={classes.input}
                size="small"
              />
              <Button
                onClick={this.searchSpecialFile}
                className={classes.btn}
                variant="contained"
              >
                搜索
              </Button>
            </Grid>
          </Grid>
          <Grid className={classes.labelBox}>
            {
              this.state.labelList.map((item, i) => (
                <div className={[classes.label, this.state.selectLabel === item ? 'active' : ''].join(' ')} key={i} onClick={() => this.handleClickLabel(item)}>
                  {item}
                </div>
              ))
            }
          </Grid>
        </Grid>

        <Grid container className={classes.container}>
          <Grid item xs={12} className={classes.list}>
            <InfiniteScroll
              dataLength={this.state.fileList.length}
              next={this.loadMore }
              hasMore={this.state.page == 0 ? false : true}
              loader={<h4>Loading...</h4>}
              endMessage={<h4>{this.showResult()}</h4>}
            >
              {this.state.fileList.map((item, i) => {
                return (
                  <DetailCard
                    key={i}
                    medical_file={item}
                    handlePreview={this.handlePreview}
                  />
                );
              })}
            </InfiniteScroll>
          </Grid>
        </Grid>

        <ToTop />
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Info));
